module.exports = __webpack_public_path__ + "img/g3.f885ae36.jpeg";